"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersRatingGrid = void 0;
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const translation_hooks_1 = require("@hooks/translation.hooks");
const user_hooks_1 = require("@hooks/user.hooks");
const expandable_grid_1 = __importDefault(require("@shared-modules/components/expandable-grid"));
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const UsersRatingGrid = (props) => {
    const { filters } = props;
    const tokens = (0, tokens_reducer_1.useTokenListForCurrentChain)();
    const translator = (0, translation_hooks_1.useComponentTranslation)("usersRatingGrid");
    const { list, setPage, loaderState } = (0, user_hooks_1.useUsersRating)(filters.period);
    return (react_1.default.createElement(expandable_grid_1.default, { columns: (0, helper_1.getCells)(translator, tokens), data: list, minWidth: "650px", getDataId: ({ user }) => user.wallet, onPageChange: setPage, totalRows: loaderState.total || 0, pageSize: loaderState.size }));
};
exports.UsersRatingGrid = UsersRatingGrid;
